import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTimeline',
  setup(__props) {

const BasicTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/BasicTimeline.vue"))
const HoveringTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/HoveringTimeline.vue"))
const VariationTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/VariationTimeline.vue"))
const HorizontalTimeline = defineAsyncComponent(() => import("@/components/theme/advance/timeline/HorizontalTimeline.vue"))
const TimelineView = defineAsyncComponent(() => import("@/components/theme/advance/timeline/TimelineView.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BasicTimeline)),
      _createVNode(_unref(HoveringTimeline)),
      _createVNode(_unref(VariationTimeline)),
      _createVNode(_unref(HorizontalTimeline)),
      _createVNode(_unref(TimelineView))
    ])
  ]))
}
}

})